import { Perform, Get } from './authorizedRequest';

export const getContainerBOL = (bol, container) =>
  Perform(Get(`nxtportdocument/${bol}/cn/${container}`), true);

export const getVesselstayBOL = (bol, vesselStay) =>
  Perform(Get(`nxtportdocument/${bol}/sn/${vesselStay}`), true);
